// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/47da399c/" + chunkId + "." + __webpack_require__.h() + ".v47da399c.js";
};